angular.module('memberPortal').factory('memberPortalHttp401Interceptor', ["$q", "$window", function($q, $window) {
  return {
    responseError: function(response) {
      if (response.status === 401) {
        window.ignoreRollbarErrors = true;
        return $window.location.reload();
      } else {
        return $q.reject(response);
      }
    }
  };
}]);
